import { Component, OnInit } from '@angular/core';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { NavController, Platform, MenuController } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ActionlistenService } from 'src/app/service/actionlisten.service';

@Component({
  selector: 'app-updateappointee',
  templateUrl: './updateappointee.page.html',
  styleUrls: ['./updateappointee.page.scss'],
})
export class UpdateappointeePage implements OnInit {

  languageConext: any;
  headingTitle: any;
  appointeeName: any;
  AppointeeData: any;
  updateappointeeData: any;
  formsubmitted: any;
  SaluationList: any;
  NationalList: any;
  RelationList: any;
  AppointeeForm: any;
  maxDate: any;
  agreecheck: boolean = false;
  CountryList: any;
  validPin: any;
  pinflg: any = 0;
  

  constructor(public api: RestapiService, public _sanitizer: DomSanitizer, public navctrl: NavController, public platform: Platform, public cmndeclaration: CommonDeclarationService, public cmndef: CommonDefinitionService, public formBuilder : FormBuilder, public actionVal : ActionlistenService, public menuCtrl: MenuController) {
    this.appointeeName = "";
    this.maxDate = "";
    this.SaluationList = [];
    this.NationalList = [];
    this.formsubmitted = false;
    this.AppointeeForm = [];
    this.CountryList = [];

    this.AppointeeForm = this.formBuilder.group({
      Salutation: ['', Validators.required],
      Firstname: ['', Validators.required],
      Surname: ['', Validators.required],
      Dob: ['', Validators.required],
      Gender: ['', Validators.required],
      Martial: ['', Validators.required],
      Relation: ['', Validators.required],
      Address: ['', Validators.required],
      Country: ['', Validators.required],
      City: ['', Validators.required],
      state: ['', Validators.required],
      pincode: ['', Validators.required],
      Nationality: ['', Validators.required],
      agreecheck:['']
    });

    this.updateappointeeData = {
      "new":"",
      "old":""
    };
    this.AppointeeData={
      "appointeeSalutation":"",
      "appointeeFirstname":"",
      "appointeeSurname":"",
      "appointeeDob":"",
      "appointeeGender":"",
      "appointeeMartial": "",
      "appointeeRelation": "",
      "appointeeAddress": "",
      "appointeeNationality": "",
      "appointeeCountry":"",
      "appointeeState":"",
      "appointeePincode":"",
      "appointeeCity":""
    };

    if (this.cmndeclaration.LanguageJson) {
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].appointeeupdate;
    }
    else {
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].appointeeupdate;
    }
    this.headingTitle = this.languageConext.heading.label;
    this.api.postapi("getPopupConfigs", {}).then(data => {
      localStorage.configPage = JSON.stringify(data);
    }, err => {
      console.log("err");
    });
    this.setDropdownList();
  }

  ionViewWillEnter() {
    this.menuCtrl.swipeEnable(false);
  }

  ngOnInit() {
    this.getAppointeeData();
  }

  checkpincode() {
    let res: any;
    let req: any;
    if (this.pinflg == 0) {
      this.pinflg = 1;
      if ((this.AppointeeData.appointeeCountry).trim() == "India") {
        console.log(this.AppointeeData.appointeePincode.length);
        if (this.AppointeeData.appointeePincode.length > 5) {
          req = {
            pinCode: this.AppointeeData.appointeePincode
          }
          this.api.postapi("verifyPincode", req).then(data => {
            res = data;
            console.log(res);
            if (res.message == 'Valid Pin Code')
              this.validPin = true;
            else
              this.validPin = false;
            this.pinflg = 0;
          }, err => {
            this.pinflg = 0;
            console.log(err);
          })
        } else {
          this.pinflg = 0;
        }
      } else {
        this.pinflg = 0;
        this.validPin = false;
      }
    }
  }

  getAppointeeData() {
    let req : any;
    let res: any;
    let response: any; 
    this.maxDate = moment(new Date()).add('-18', 'years').format('YYYY-MM-DD');
    this.cmndeclaration.getstoreProcess("profile").then(data=>{
      res = data;
      req = {
        "userSessionID": localStorage.userSessionID,
        "userChatSessionId": localStorage.userChatSessionId,
        "mobileNo": res.mobileNo,
        "requestType": "getAppointeeDtls",
      } 
      this.api.postapi("updateDetails",req).then(data => {
        console.log(data);
        response = data;
        if(response.appointee != undefined && response.appointee != ""){
          this.updateappointeeData.old = response.appointee;
          response = response.appointee;
          if(response.appointeeFirstName != "" && response.appointeeFirstName != null && response.appointeeFirstName != "null"){
            this.appointeeName = response.appointeeFirstName;
            // this.AppointeeData.appointeeFirstname = response.appointeeFirstName;
          }
          if(response.appointeeSurname != "" && response.appointeeSurname != null && response.appointeeSurname != "null"){
            this.appointeeName = this.appointeeName+" "+response.appointeeSurname;
            // this.AppointeeData.appointeeSurname  = response.appointeeSurname;
          }

          // if(response.appointeeDOB != "" && response.appointeeDOB != null && response.appointeeDOB != "NA" && response.appointeeDOB != "null")
            // this.AppointeeData.appointeeDob = response.appointeeDOB;
        }
      }, err => {
        console.log(data);
      })
    });
  }

  async setDropdownList() {
    let res : any;

    await this.cmndeclaration.getstoreProcess("nomineesalgen").then(data=>{
      res = data
      this.SaluationList = res;
    });

    await this.cmndeclaration.getstoreProcess("nomineeNationality").then(data=>{
      res = data
      this.NationalList = (res).split(",");
    });
    await this.cmndeclaration.getstoreProcess("nomineeRelation").then(data=>{
      res = data
      this.RelationList = res;
    });

    await this.cmndeclaration.getstoreProcess("nomineeCountry").then(data=>{
      res = data
      this.CountryList = (res).split(",");
    });
  }

  showDatepicker(){
    var date = new Date().getDate();
    var month = (new Date().getMonth() + 1);

    if (this.AppointeeData.appointeeDob == undefined || this.AppointeeData.appointeeDob == null || this.AppointeeData.appointeeDob == "") {
      var year = moment(new Date()).add('-18', 'years').format('YYYY');
      let fulldate = new Date(month + '/' + date + '/' + year);
      let mdte = new Date();
      this.cmndef.showdatePicker(mdte, "", fulldate).then((data: any) => {
        let dateSplit = String(data).split("/");
        let demo = dateSplit[2];
        if(Number(year) < Number(demo))
          this.AppointeeData.appointeeDob = moment(new Date(dateSplit[1] + "/" + dateSplit[0] + "/" + dateSplit[2])).add('-18', 'years').format('DD/MM/YYYY');
        else
        this.AppointeeData.appointeeDob = data;
      }, err => {
        console.log(err);
      });
    }
    else {
      let split = this.AppointeeData.appointeeDob.split("/");
      let sdate = split[1] + "/" + split[0] + "/" + split[2]
      let d = new Date(sdate);
      var year = moment(new Date()).add('-18', 'years').format('YYYY')
      let fulldate = new Date(month + '/' + date + '/' + year);
      this.cmndef.showdatePicker(d, "", fulldate).then(data => {
        this.AppointeeData.appointeeDob = data;
      }, err => {
        console.log(err);
      });
    }
  }

  async UpdateAppointee(){
    let res: any;
    console.log(this.agreecheck);
    console.log(this.AppointeeForm)
    if(this.AppointeeForm.valid && this.agreecheck == true && (this.validPin || (this.AppointeeData.appointeeCountry).trim() != "India")){
      await this.cmndef.loaderstart();
      if(this.cmndeclaration.BrowserBuild == 1){
        this.AppointeeData.appointeeDob = moment(this.AppointeeData.appointeeDob).format("DD/MM/YYYY");
      }
      this.updateappointeeData.new=this.AppointeeData;
      this.updateappointeeData["actionType"] = "APPOINTEE_UPDATE"
      this.updateappointeeData["userChatSessionID"] = localStorage.userChatSessionId
      this.updateappointeeData["userSessionID"] = localStorage.userSessionID;
      console.log(JSON.stringify(this.updateappointeeData));
      this.api.clickenventcap("submit_"+this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
      await this.api.postapi("akeiraVAAction", this.updateappointeeData).then(async data => {
        res = data;
        await this.cmndef.loaderend();
        this.cmndeclaration.TamlismaJson = res["chatResp"][0];
        sessionStorage.CurrentPage = "/va/chat";
        this.navctrl.navigateRoot("/va/chat");
      },async  err => {
        console.log(err);
        await this.cmndef.loaderend();
      })
    }
  }

  Validatation(flg: any) {
    if (flg == "firstname") {
      console.log(this.AppointeeData.appointeeFirstname)
      this.AppointeeData.appointeeFirstname = this.AppointeeData.appointeeFirstname.replace(/[^a-zA-Z ]+/g, '');
    } else if (flg == "Surname") {
      console.log(this.AppointeeData.Surname)
      this.AppointeeData.appointeeSurname = this.AppointeeData.appointeeSurname.replace(/[^a-zA-Z ]+/g, '');
    } else if (flg == "city") {
      console.log(this.AppointeeData.appointeeCity)
      this.AppointeeData.appointeeCity = this.AppointeeData.appointeeCity.replace(/[^a-zA-Z ]+/g, '');
    } else if (flg == "state") {
      console.log(this.AppointeeData.appointeeState)
      this.AppointeeData.appointeeState = this.AppointeeData.appointeeState.replace(/[^a-zA-Z ]+/g, '');
    } else if (flg == "pincode") {
      this.AppointeeData.appointeePincode = this.AppointeeData.appointeePincode.replace(/[^0-9]+/g, '');
    }
  }

}
